const breakpoints = ['36em', '62em', '80em'];
export const theme = {
  breakpoints,
  fonts: {
    normal: 'Avenir, Lato, Nunito Sans, apple-system, BlinkMacSystemFont, arial, sans-serif'
  },
  fontSizes: ['10px', '12px', '14px', '15px', '16px', '17px', '18px', '22px', '24px', '30px', '32px', '40px', '48px'],
  textStyles: {
    caps: {
      textTransform: 'uppercase',
      letterSpacing: 1.2
    }
  },
  space: ['0', '6px', '12px', '24px', '36px', '48px', '60px', '72px', '90px'],
  lineHeights: ['12px', '18px', '24px', '36px', '48px'],
  radii: [0, '4px', '6px', '12px', '24px', '36px', '48px', '100%'],
  shadows: ['none', '0 1px 1px rgba(0, 0, 0, 0.14)', '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)', '0 3px 3px 0 rgba(0, 0, 0, 0.14),0 1px 7px 0 rgba(0, 0, 0, 0.12),0 3px 1px -1px rgba(0, 0, 0, 0.2)', '0 4px 5px 0 rgba(0,0,0,0.14),0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3)', '0 8px 17px 2px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0, 0, 0, 0.2)', '0 14px 36px 0 rgba(75, 80, 94, 0.08)'],
  colors: {
    brandDark: '#36424A',
    brandLight: '#FFFFFF',
    nightgraph: '#AED8E5',
    seemore: '#94C7D4',
    text: {
      primary: '#36424A',
      primaryCardColor: '#36424A',
      secondary: '#6E7A83',
      secondaryCardColor: '#6E7A83',
      caption: '#B6BABD'
    },
    accent: {
      shape: '#3B88FD',
      text: '#9BC5FC'
    },
    background: {
      pureWhite: '#FFFFFF',
      spaceWhite: '#FAFAFA',
      grainsboro: '#F4F4F4',
      smokeWhite: '#F7F7F7',
      snowPlanet: '#F6F7FB',
      snow: '#F9F9F9',
      mercury: '#E2E4E5',
      night: '#1A1D1F',
      lightBlue: '#B5DDE8',
      blue: '#3B90FD',
      positive: '#86D9C536',
      temporary: '#fbb86d36',
      negative: '#ef8b8b36',
      moscow: 'rgba(168, 200, 254, 0.5)'
    },
    feeling: {
      positive: '#86D9C5',
      temporary: '#FBB86D',
      negative: '#EF8B8B',
      neutral: '#6E7A83'
    },
    support: {
      manchester: '#FA8499',
      marseille: '#9EDCF6',
      miami: '#89EBDD',
      marrakesh: '#FAC496',
      moscow: '#A8C8FE',
      mannheim: '#7E97A8'
    }
  },
  avatarSizes: {
    nano: {
      width: 26,
      height: 26
    },
    micro: {
      width: 30,
      height: 30
    },
    tiny: {
      width: 36,
      height: 36
    },
    small: {
      width: 48,
      height: 48
    },
    medium: {
      width: 60,
      height: 60
    },
    large: {
      width: 72,
      height: 72
    },
    huge: {
      width: 84,
      height: 84
    }
  },
  mediaQueries: {
    mobile: "screen and (min-width: 0px) and (max-width: 575px)",
    tablet: "screen and (min-width: 576px) and (max-width: 991px)",
    desktop: "screen and (min-width: 992px) and (max-width: 1280px)",
    wideScreen: "screen and (min-width: 1281px) and (max-width: 1920px)",
    keyboard: "screen and (min-height: 0px) and (max-height: 440px)",
    retina: "only screen and (-webkit-min-device-pixel-ratio: 1.5),only screen and (min--moz-device-pixel-ratio: 1.5),only screen and (-o-min-device-pixel-ratio: 3/2),only screen and (min-device-pixel-ratio: 1.5),only screen and (min-resolution: 192dpi)"
  }
};
[theme.breakpoints.mobile, theme.breakpoints.tablet, theme.breakpoints.desktop] = theme.breakpoints;